var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container dispatch-manage-container"},[_c('div',{staticClass:"left-nav-content"},[_c('leftNav',{attrs:{"navList":_vm.leftNavList},on:{"on-select":_vm.handleNavSelect}})],1),_c('div',{staticClass:"router-view-content"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }